import { render } from "./FreeInput.vue?vue&type=template&id=2dc80f76&scoped=true"
import script from "./FreeInput.vue?vue&type=script&lang=js"
export * from "./FreeInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmattern/Documents/3 - GIT/studio-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc80f76"]])

export default __exports__